import { render } from "./TimeBeforeStartCounter.vue?vue&type=template&id=3d7af475"
import script from "./TimeBeforeStartCounter.vue?vue&type=script&lang=js"
export * from "./TimeBeforeStartCounter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__